import { LngLatLike } from 'mapbox-gl';

export const SAHEL_BOUNDS: [LngLatLike, LngLatLike] = [
  { lat: 30.767351, lng: 27.357489 },
  { lat: 31.252468, lng: 29.390252 }
];

export const SAHEL_CENTER: LngLatLike = [28.3738705, 31.0899095];

export const SAHEL_ZOOM = 10.5;

export const NAWY_NOW_ZOOM = 5.5;
